export const html = "<p>Taste wine where winemaking began, in Areni.</p>\n";
export const leadHtml = "<p>Taste wine where winemaking began, in Areni.</p>\n";
export const bodyHtml = "";
export const metaText = "Taste wine where winemaking began, in Areni.";